<template>
  <div class="question column" :class="width">
    <div class="question-content card">
      <div
        class="card-content"
        v-html="decodeHtml(question.question[lang])"
        v-if="isQuotaFull"
      ></div>
    </div>
  </div>
</template>

<script>
import { QuestionMixin } from "@/mixins/question";
import { multipleQuotaFullDetail } from "@/api/response";
import { checkConditions } from "@/utils/question";

export default {
  name: "MultipleQuotaFull",
  mixins: [QuestionMixin],
  data() {
    return {
      isQuotaFull: false,
      surveyCode: this.$route.params?.code,
      resultValue: "N",
      width: "is-8",
    };
  },
  methods: {
    async checkMultipleQuotaFull() {
      try {
        const response = await multipleQuotaFullDetail(
          this.surveyCode,
          this.question?.qid,
        );

        const rowStats = response?.data?.rows || response?.data?.data?.rows || [];

        const rows = this.question?.options?.quota_rows || [];

        // Mix in hiddenData (respondent info) with survey results for full context
        const context = Object.assign(
          {},
          this.hiddenData,
          this.result,
          this.value,
        );

        let isFull = false;
        let fullQuotaId = null;
        const inputData = {};
        for (let i = 0; i < rows.length; i++) {
          const row = rows[i];
          const stat = rowStats.find((r) => r.quota_id === row.quota_id) || rowStats.find((r) => r.name === row.name) || rowStats.find((r) => r.index === i);

          if (stat) {
            const isMatch = checkConditions(row.conditions, context);
            const quotaId = row.quota_id || `${this.question.qid}_${i + 1}`;
            if (isMatch) {
              if (stat.current >= row.quota) {
                if (!isFull) {
                  isFull = true;
                  fullQuotaId = quotaId;
                }
                inputData[quotaId] = "Y";
              } else {
                inputData[quotaId] = "N";
              }
            } else {
              inputData[quotaId] = null; // non-matching → quota_id: null in result
            }
          }
        }

        if (isFull) {
          inputData[fullQuotaId] = "Y";
        }

        this.$emit("input", inputData);

        if (isFull) {
          this.isQuotaFull = true;
          this.$emit("multiple-quota-full");
        }
        this.$emit("submit");
      } catch (error) {
        console.error("Error checking Multiple Quota Full:", error);
        this.$emit("submit");
      }
    },
  },
  async created() {
    await this.checkMultipleQuotaFull();
  },
};
</script>
